module.exports = __webpack_public_path__ + "static/img/iconyangshengqi_guanbi_24_hei.f6ef122c.png";